import React, { useContext, useEffect, useState, useCallback } from "react";

import "./stylesPromotionsManagement.css";
import AppContext from "../../../context/AppContext";
import { SIDER_TABS } from "../../../utils/Constants";

import PurchaseIcon from "../../../assets/icons/ic_purchase-match.svg";
import { Plus } from "react-feather";
import PurchasesByType from "./PurchasesByType/PurchasesByType";
import Purchases from "./Purchases/Purchases";
import CustomDatePicker from "../../CommonComponents/CustomDatePicker/CustomDatePicker";

import CustomAutoComplete from "../../CommonComponents/CustomAutoComplete/CustomAutoComplete";
import { Select, Table } from "antd";
import { CaretDownOutlined, CaretUpOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import createPrivateAdminPanelInstance from "../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../api/ApiRoutes";
import { AppStrings } from "../../../utils/constants/AppStrings";
import { usePageTitle } from "../../CommonComponents/Layout/PageTitleContext";
import { getAdminNow } from "../../../utils/dateService";

function PromotionsManagement() {
  const navigate = useNavigate();
  usePageTitle(AppStrings.PROMOTIONS_MANAGEMENT);

  const { setActiveSidebarTab } = useContext(AppContext);
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(token?.AccessToken, true);

  const todayRange = [getAdminNow(), getAdminNow()];
  const [dates, setDates] = useState(todayRange);
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [isApiRunning, setIsApiRunning] = useState(false);
  const [dashboardData, setDashboardData] = useState({
    purchases: 0,
    players_received: 0,
    players_used: 0,
    purchases_by_type: {
      purchase_match: 0,
      free_bet: 0,
      free_squares: 0,
      profit_boost: 0,
      insurance_bets: 0
    }
  });

  console.log(dashboardData, "dashboardData");

  const fetchDashboardData = async () => {
    setIsApiRunning(true);
    try {
      const response = await PrivateAdminPanelInstance.get(
        API_ROUTES.GET_PROMOTIONS_DASHBOARD,
        {
          params: {
            start_date: dates[0].format('YYYY-MM-DD'),
            end_date: dates[1].format('YYYY-MM-DD')
          }
        }
      );
      console.log(response, "response");
      
      if (response?.data?.success) {
        setDashboardData(response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching promotions dashboard data:", error);
    } finally {
      setIsApiRunning(false);
    }
  };

  useEffect(() => {
    if (dates && dates[0] && dates[1]) {
      fetchDashboardData();
    }
  }, [dates]);

  const tableHeaders = [
    AppStrings.PAM_PROMOTIONS_STATUS_ACTIVE,
    AppStrings.PAM_PROMOTIONS_STATUS_NOT_STARTED,
    AppStrings.SUSPENDED,
    AppStrings.PAM_PROMOTIONS_STATUS_FINISHED,
    AppStrings.PAM_PROMOTIONS_STATUS_DRAFTS,
    AppStrings.PAM_PROMOTIONS_STATUS_ARCHIVED,
  ];

  const promotions = [
    { id: 1, label: "Promotion 1", value: "Promotion 1" },
    { id: 2, label: "Promotion 2", value: "Promotion 2" },
    { id: 3, label: "Promotion 3", value: "Promotion 3" },
    { id: 4, label: "Promotion 4", value: "Promotion 4" },
    { id: 5, label: "Promotion 5", value: "Promotion 5" },
    { id: 6, label: "Promotion 6", value: "Promotion 6" },
  ];

  const columns = [
    {
      title: AppStrings.ID,
      dataIndex: "id",
      key: "id",
      sorter: (a, b) => a.id - b.id,
    },
    {
      title: AppStrings.NAME,
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: AppStrings.TYPE,
      dataIndex: "type",
      key: "type",
      sorter: (a, b) => a.type.localeCompare(b.type),
    },
    {
      title: AppStrings.STATUS,
      dataIndex: "status",
      key: "status",
      sorter: (a, b) => a.status.localeCompare(b.status),
      render: (text) => (
        <span className={`status ${text.toLowerCase()}`}>{text}</span>
      ),
    },
    {
      title: AppStrings.START_DATE,
      dataIndex: "startDate",
      key: "startDate",
      sorter: (a, b) => new Date(a.startDate) - new Date(b.startDate),
    },
    {
      title: AppStrings.END_DATE,
      dataIndex: "endDate",
      key: "endDate",
      sorter: (a, b) => new Date(a.endDate) - new Date(b.endDate),
    },
    {
      title: AppStrings.PROFIT,
      dataIndex: "profit",
      key: "profit",
      sorter: (a, b) => a.profit - b.profit,
      render: (value) => (
        <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          {value.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          })}
          <p className="up">
            <CaretUpOutlined /> 15%
          </p>
        </span>
      ),
    },
    {
      title: AppStrings.VOLUME,
      dataIndex: "volume",
      key: "volume",
      sorter: (a, b) => a.volume - b.volume,
      render: (value) => (
        <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          {value.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          })}
          <p className="down">
            <CaretDownOutlined /> 10%
          </p>
        </span>
      ),
    },
    {
      title: AppStrings.WAGERED,
      dataIndex: "wagered",
      key: "wagered",
      sorter: (a, b) => a.wagered - b.wagered,
      render: (value) => (
        <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          {value.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          })}
          <p className="down">
            <CaretDownOutlined /> 5%
          </p>
        </span>
      ),
    },
    {
      title: AppStrings.PAID_OUT,
      dataIndex: "paidout",
      key: "paidout",
      sorter: (a, b) => a.paidout - b.paidout,
      render: (value) => (
        <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          {value.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          })}
          <p className="up">
            {" "}
            <CaretUpOutlined /> 10%
          </p>
        </span>
      ),
    },
    {
      title: AppStrings.RECEIVED,
      dataIndex: "received",
      key: "received",
      sorter: (a, b) => a.received - b.received,
      render: (value) =>
        value.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        }),
    },
    {
      title: AppStrings.ACTIVATED,
      dataIndex: "activated",
      key: "activated",
      sorter: (a, b) => a.activated - b.activated,
      render: (value) => (value ? AppStrings.YES : AppStrings.NO),
    },
  ];

  const dataSource = Array.from({ length: 100 }, (_, index) => ({
    key: index + 1,
    id: index + 1,
    name: `Campaign ${index + 1}`,
    type: ["Bonus", "Cashback", "Free Bet"][index % 3],
    status: Math.random() > 0.5 ? "Active" : "Inactive",
    startDate: `2023-09-${String((index % 28) + 1).padStart(2, "0")}`,
    endDate: `2023-10-${String((index % 28) + 1).padStart(2, "0")}`,
    profit: Math.floor(Math.random() * 20000) - 10000,
    volume: Math.floor(Math.random() * 100000) + 5000,
    wagered: Math.floor(Math.random() * 90000) + 1000,
    paidout: Math.floor(Math.random() * 70000) + 2000,
    received: Math.floor(Math.random() * 60000) + 3000,
    activated: Math.random() > 0.5,
  }));

  const handleRowClick = (record) => {
    const campaignSlug = record.name.replace(/\s+/g, "-").toLowerCase();
    navigate(`/promotions-management/campaign/${campaignSlug}`);
  };

  useEffect(() => {
    setActiveSidebarTab(SIDER_TABS.PROMOTIONS, "BONUS_CONTROLS");
  }, []);

  return (
    <>
      <div className="promotions-management-container">
        <div className="promotions-management">
          <>
            <div className="promotions-management-content">
              <div className="promotions-management-content-header">
                <img src={PurchaseIcon} alt={AppStrings.PAM_PROMOTIONS_PURCHASE_ICON_ALT} />
                <h2>{AppStrings.CREATE_NEW_PROMO_NOTIFICATION}</h2>
                <p>
                  {AppStrings.CREATE_NEW_PROMO_NOTIFICATION_DESCRIPTION}
                </p>
                <div
                  className="plus-icon"
                  onClick={() => {
                    navigate("/promotions-management/new-promotion");
                  }}
                >
                  <Plus size={20} />
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div className="h2-container">
                  <h2>{AppStrings.ALL_PROMOTIONS}</h2>
                  <p>{AppStrings.ACTIVE} 16</p>
                </div>
                <CustomDatePicker
                  getData={fetchDashboardData}
                  dates={dates}
                  setDates={setDates}
                  showPresets={true}
                />
              </div>
              <Purchases isApiRunning={isApiRunning} dashboardData={dashboardData} />
              <PurchasesByType isApiRunning={isApiRunning} dashboardData={dashboardData} />
              <div className="promotions-management-table-container">
                <div className="promotions-management-table-container-header">
                  <h2>{AppStrings.ALL_PROMOTIONS}</h2>
                  <CustomDatePicker
                    getData={() => {}}
                    dates={dates}
                    setDates={setDates}
                    showPresets={true}
                  />
                </div>
                <div className="promotions-management-selector-container">
                  <div className="promotions-management-selector">
                    <Select
                      mode="single"
                      placeholder={AppStrings.SEARCH_BY_ID}
                      onChange={() => {}}
                      options={promotions}
                    />
                  </div>
                  <CustomAutoComplete
                    placeholder={AppStrings.SEARCH}
                    allOptions={promotions}
                    handleChange={() => {}}
                    clearOptions={() => {}}
                  />
                </div>
                <div className="promotions-management-table">
                  <div className="table-headers">
                    {tableHeaders.map((header, index) => (
                      <div
                        key={index}
                        className={`table-header ${
                          selectedTabIndex === index ? "active" : ""
                        }`}
                        onClick={() => setSelectedTabIndex(index)}
                      >
                        <p>{header}</p>
                      </div>
                    ))}
                  </div>
                  <Table
                    dataSource={dataSource}
                    columns={columns}
                    scroll={{ x: 1700 }}
                    onRow={(record) => {
                      return {
                        onClick: () => handleRowClick(record), // clique na linha
                      };
                    }}
                  />
                </div>
              </div>
            </div>
          </>
        </div>
      </div>
    </>
  );
}

export default PromotionsManagement;
